// Angular
import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { CommonModule } from "@angular/common";
import { ReactiveFormsModule } from "@angular/forms";
import { DragDropModule } from "@angular/cdk/drag-drop";
import { MatCardModule } from "@angular/material/card";
import { MatDialogModule } from "@angular/material/dialog";
import { MatMenuModule } from "@angular/material/menu";

import { NgbModule } from "@ng-bootstrap/ng-bootstrap";

// Core Module
import { PartialsModule } from "../../partials/partials.module";
import { CreateInvoiceComponent } from "./create/create-invoice.component";
import { FetchInvoiceComponent } from "./fetch/fetch-invoice.component";
import { InvoiceListComponent } from "./list/invoice-list.component";
import { InvoiceDetailComponent } from "./detail/invoice-detail.component";
import { InvoiceDetailEditDialog } from "./detail/edit/invoice-detail-edit.component";
import { InvoiceSplitComponent } from "./detail/split/invoice-split.component";

@NgModule({
	imports: [
		CommonModule,
		PartialsModule,
		ReactiveFormsModule,
		NgbModule,
		DragDropModule,
		MatCardModule,
		MatDialogModule,
		MatMenuModule,
		RouterModule.forChild([
			{
				path: "",
				component: InvoiceListComponent,
			},
			{
				path: ":invoiceID",
				component: InvoiceDetailComponent,
			},
		]),
	],
	providers: [],
	declarations: [
		CreateInvoiceComponent,
		FetchInvoiceComponent,
		InvoiceListComponent,
		InvoiceDetailComponent,
		InvoiceDetailEditDialog,
		InvoiceSplitComponent,
	],
})
export class InvoicesModule {}
